const translations = {
	page_title: "Souscriptions informations",
	title: "Souscriptions",
	cgp: "CGP :",
	email_cgp: "Email :",
	email_administratif: "Email administratif :",
	office: "Cabinet",
	document_management: "Gestion des documents",
	notify_cgp_transfer: "Prévenir CGP transmission",
	success_notify_cgp_transfer: "Mail envoyé avec succès",
	notify_cgp_transfer_at: "Mail déjà envoyé le :",
	send_legal_docs: "Envoi des docs d'informations",
	send_legal_docs_at: "Documents déjà envoyés le :",
	success_send_legal_docs: "Documents envoyés avec succès",
	archive: "Archiver",
	subscription_type: "Type de souscription :",
	detention_percentage: "% de détention :",
	contrepartie: "Contrepartie :",
	contrepartie_sans: "Sans contrepartie",
	contrepartie_modal: {
		title: "Modification contrepartie",
		label: "Nom de la contrepartie",
		placeholder: "Laisser vide pour 'Sans contrepartie'",
		cancel: "Annuler",
		save: "Enregistrer",
	},
	scpi: "Produit :",
	nbParts: "Nb parts :",
	cabinet: "Cabinet :",
	membre_reseau: "Réseau :",
	subscribed_amount: "Montant souscrit :",
	reception_date: "Date de réception :",
	validation_date: "Date de validation :",
	due_date: "Date de jouissance :",
	demembrement_end_date: "Date de fin de démembrement :",
	payout_date: "Date de versement des premiers loyers :",
	sub_pages: {
		subscribers: {
			page_title: "Souscripteur(s)",
		},
		payment: {
			page_title: "Mode de règlement",
		},
		bulletin: {
			page_title: "Bulletin de souscription",
		},
		files: {
			page_title: "Pièces justificatives",
		},
		signable_documents: {
			page_title: "Documents de souscription",
		},
		signed_documents: {
			page_title: "Documents signés",
		},
	},
	rto_anomaly: "RTO signalé - message du partenaire :",
	product_anomaly: "Produit signalé - message du partenaire :",
	archive_subscription_modal: {
		title: "Êtes-vous sûr ?",
		description:
			"Attention : l'archivage concerne toute la souscription.\nSi elle inclut plusieurs produits, ils seront tous archivés.\n\nCette action est réversible - Demander à Smart-chain pour un désarchivage.",
		legacy_description:
			"Seule cette opération reprise sera archivée : les autres opérations du client ne changent pas.\n\nCette action est réversible : demandez un désarchivage au support.",
		confirm_button: "Archiver",
		cancel_button: "Annuler",
	},
};

export default translations;
